import download from "@/utils/download";

/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
};
export default {
    //消息推送配置

  dden: {
    query:`${base.url}/emg/dden/list`,
    export:`${base.url}/emg/dden/export`,
    getGCrExtnId:`${base.url}/emg/dden/getGCrExtnId`,
    add:`${base.url}/emg/dden/add`,

    validatePno:`${base.url}/emg/dden/validatePno`,
    classifyPnos:`${base.url}/emg/dden/classifyPnos`,

    stats:`${base.url}/emg/dden/stats`,
    downloadStats:`${base.url}/emg/dden/downloadStats`,

    getTemplates:`${base.url}/emg/dden/getTemplates`,
    saveTemplates:`${base.url}/emg/dden/saveTemplates`,
    getFilledTemplates:`${base.url}/emg/dden/getFilledTemplates`
  }
};


